import actions from '@/core/store/documentos/pncp/actions'

export default {
	actions,
}
